<mat-nav-list class="sidenav-list">
    <mat-list-item 
        routerLinkActive="active" 
        [routerLink]="['/home']"
        (click)="onToggleClose()"
    >
        <i class="icon icon-home"></i>
        {{ 'SIDEMENU_HOME_LABEL' | translate }}
    </mat-list-item>

    <mat-list-item 
        routerLinkActive="active" 
        [routerLink]="['/feedback']"
        (click)="onToggleClose()"
    >
        <i class="icon icon-message"></i>
        {{ 'SIDEMENU_FEEDBACK_LABEL' | translate }}
    </mat-list-item>

    <mat-list-item 
        routerLinkActive="active" 
        [routerLink]="['/tariffs']"
        (click)="onToggleClose()"
    >
        <i class="icon icon-tariff"></i>
        {{ 'SIDEMENU_TARIFFS_LABEL' | translate }}
    </mat-list-item>

    <mat-list-item 
        routerLinkActive="active" 
        [routerLink]="['/account']"
        (click)="onToggleClose()"
    >
        <i class="icon icon-message"></i>
        {{ 'SIDEMENU_PROFILE_LABEL' | translate }}
    </mat-list-item>

    <mat-expansion-panel [class.mat-elevation-z0]="true" dense>
        <mat-expansion-panel-header style="height: 48px;">
            <i class="icon icon-setting"></i>
            {{ 'SIDEMENU_SETTINGS_LABEL' | translate }}
        </mat-expansion-panel-header>
        <mat-nav-list dense>
            <mat-expansion-panel [class.mat-elevation-z0]="true" dense>
                <mat-expansion-panel-header style="height: 48px;">
                    <i class="icon icon-language"></i>
                    {{ 'SIDEMENU_SETTINGS_LANGUAGE_LABEL' | translate }}
                </mat-expansion-panel-header>
                <mat-nav-list dense>
                    <mat-list-item
                        *ngFor="let lang of translate.getLangs()"
                        (click)="onLanguageChangeClicked(lang)"
                    >
                    <i [ngClass]="{ 'icon icon-true_icon': lang === translate.currentLang }"></i>
                        {{ 'SIDEMENU_LANGUAGE_' + lang + '_LABEL' | uppercase | translate }}
                    </mat-list-item>
                </mat-nav-list>
            </mat-expansion-panel>
        </mat-nav-list>
    </mat-expansion-panel>
 
    <mat-list-item *ngIf="isLogin === true"
        (click)="onLogOut()"
    >
        <i class="icon icon-menu_logout"></i>
        {{ 'SIDEMENU_LOGOUT_LABEL' | translate }}
    </mat-list-item>

    <mat-list-item *ngIf="isLogin === false"
        (click)="onLogin()"
    >
        <i class="icon icon-menu_login"></i>
        {{ 'SIDEMENU_LOGIN_LABEL' | translate }}
    </mat-list-item>

    <div class="versionText">
        Version: {{version}}
    </div>

</mat-nav-list>